import { render, staticRenderFns } from "./calendarCard.vue?vue&type=template&id=46ad90a2&scoped=true&"
import script from "./calendarCard.vue?vue&type=script&lang=js&"
export * from "./calendarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad90a2",
  null
  
)

export default component.exports